import { useEffect, useRef } from 'react';
import { Paper, useTheme } from '@mui/material';

type ScrollableContentProps = {
  height?: string;
  handleScrollComplete?: () => void;
  children: React.ReactNode;
};

const ScrollableContent = ({
  height,
  handleScrollComplete,
  children,
}: ScrollableContentProps) => {
  const theme = useTheme();
  const ref = useRef<HTMLDivElement>(null);
  const styleProps = {
    height: height || '335px',
    maxWidth: '900px',
    overflowY: 'auto',
    padding: theme.spacing(3),
    fontFamily: 'Source Sans Pro',
    fontSize: '16px',
    fontStyle: 'normal',
    fontWeight: 400,
    lineHeight: '24px',
    letterSpacing: '0.15px',

    boxShadow:
      '0px 3px 14px 2px rgba(0, 0, 0, 0.06), 0px 8px 10px 1px rgba(0, 0, 0, 0.07), 0px 5px 5px -3px rgba(0, 0, 0, 0.1)',
  };
  const handleScroll = () => {
    if (!ref.current) return;
    const { scrollTop, scrollHeight, clientHeight } = ref.current;
    if (Math.abs(scrollHeight - scrollTop - clientHeight) < 100) {
      handleScrollComplete?.();
    }
  };

  useEffect(() => {
    const scrollableElement = ref.current;
    scrollableElement?.addEventListener('scroll', handleScroll);
    return () => {
      scrollableElement?.removeEventListener('scroll', handleScroll);
    };
  }, []);

  return (
    <Paper
      ref={ref}
      elevation={8}
      sx={{ ...styleProps }}
      onScroll={handleScroll}>
      {children}
    </Paper>
  );
};

export { ScrollableContent };
